"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.keys");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.object.values");

require("core-js/modules/es6.array.map");

var _map2 = _interopRequireDefault(require("lodash/map"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _classes = _interopRequireDefault(require("@nerdwallet/base-styles/classes"));

var _deprecate = require("@nerdwallet/deprecate");

var _reactActionBlock = _interopRequireDefault(require("@nerdwallet/react-action-block"));

var _reactLink = _interopRequireDefault(require("@nerdwallet/react-link"));

var _reactAccessibility = require("@nerdwallet/react-accessibility");

var _reactInputGroup = _interopRequireWildcard(require("@nerdwallet/react-input-group"));

var _inputModule = _interopRequireDefault(require("./input.module.less"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Input = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  // Determine if we should compose an Input
  // within an InputGroup
  var willRenderInputGroup = (0, _reactInputGroup.shouldRenderInputGroup)(props);
  (0, _deprecate.useDeprecatedPropsWarning)({
    component: 'Input',
    deprecatedProps: [{
      deprecated: 'icon',
      migration: 'Custom icons are no longer recommended for use in designs.',
      version: '9.5.0'
    }],
    props: props
  });

  var className = props.className,
      dangerouslyForceFocusStyling = props.dangerouslyForceFocusStyling,
      dangerouslyForceHoverStyling = props.dangerouslyForceHoverStyling,
      disabled = props.disabled,
      error = props.error,
      feedbackMessages = props.feedbackMessages,
      fullWidth = props.fullWidth,
      icon = props.icon,
      idProp = props.id,
      inputRef = props.inputRef,
      styleProp = props.style,
      _props$actionLabel = props.actionLabel,
      actionLabel = _props$actionLabel === void 0 ? null : _props$actionLabel,
      _props$actionProps = props.actionProps,
      actionProps = _props$actionProps === void 0 ? null : _props$actionProps,
      label = props.label,
      helpMessage = props.helpMessage,
      errorMessage = props.errorMessage,
      tooltip = props.tooltip,
      tooltipPlacement = props.tooltipPlacement,
      otherProps = _objectWithoutProperties(props, ["className", "dangerouslyForceFocusStyling", "dangerouslyForceHoverStyling", "disabled", "error", "feedbackMessages", "fullWidth", "icon", "id", "inputRef", "style", "actionLabel", "actionProps", "label", "helpMessage", "errorMessage", "tooltip", "tooltipPlacement"]);

  var id = (0, _reactAccessibility.useId)(idProp);
  var errorMessageId = "".concat(id, "-error-message");
  var helpMessageId = "".concat(id, "-help-message");
  var parsedFeedbackMessages = (feedbackMessages || []).map(function (f, i) {
    return _objectSpread(_objectSpread({}, f), {}, {
      id: "".concat(id, "-feedback-").concat(i)
    });
  }); // It's safe to unconditionally render all error, feedback, and help IDs in `aria-describedby`, even
  // if there isn't a help/error/feedback message currently being shown. If
  // `aria-describedby` refers to an element that doesn't exist, it just skips it.

  var ariaDescribedByIds = [errorMessageId, helpMessageId].concat(_toConsumableArray((0, _map2["default"])(parsedFeedbackMessages, 'id'))).join(' '); // Normally, we can render the input *as* an `<ActionBlock>` and avoid extra
  // DOM elements.

  var ActionBlockInputWithoutAction = /*#__PURE__*/_react["default"].createElement(_reactActionBlock["default"], _extends({
    "aria-describedby": ariaDescribedByIds,
    "aria-invalid": error ? 'true' : undefined,
    component: "input",
    className: (0, _classnames["default"])( // Only apply className if an input group will not be rendered
    // or the same className will be applied twice
    _defineProperty({}, className, !willRenderInputGroup), // eslint-disable-next-line react/prop-types -- directive added automatically by Shepherd migration
    _inputModule["default"].input, // eslint-disable-next-line react/prop-types -- directive added automatically by Shepherd migration
    _inputModule["default"]['input-height'], (0, _classes["default"])({
      'width-100': fullWidth
    })),
    disabled: disabled,
    error: error,
    id: id // `inputRef` exists mostly for backwards compatibility
    ,
    ref: inputRef || ref,
    style: styleProp,
    dangerouslyForceFocusStyling: dangerouslyForceFocusStyling,
    dangerouslyForceHoverStyling: dangerouslyForceHoverStyling
  }, otherProps)); // If we need to show an action next to the input, we need to render the
  // input *inside* the `<ActionBlock>`.


  var ActionBlockInputWithAction = /*#__PURE__*/_react["default"].createElement(_reactActionBlock["default"], {
    mode: "container",
    component: "div",
    className: (0, _classnames["default"])( // Only apply className if an input group will not be rendered
    // or the same className will be applied twice
    _defineProperty({}, className, !willRenderInputGroup), // eslint-disable-next-line react/prop-types -- directive added automatically by Shepherd migration
    _inputModule["default"]['input-height'], (0, _classes["default"])('display-inline-flex', 'align-items-center', {
      'width-100': fullWidth
    }), _defineProperty({}, _inputModule["default"]['action-block-container'], !fullWidth)),
    disabled: disabled,
    error: error,
    style: styleProp,
    dangerouslyForceFocusStyling: dangerouslyForceFocusStyling,
    dangerouslyForceHoverStyling: dangerouslyForceHoverStyling
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({
    "aria-invalid": error ? 'true' : undefined,
    "aria-describedby": ariaDescribedByIds,
    className: (0, _classnames["default"])( // eslint-disable-next-line react/prop-types -- directive added automatically by Shepherd migration
    _inputModule["default"].input, // eslint-disable-next-line react/prop-types -- directive added automatically by Shepherd migration
    _inputModule["default"]['inner-input'], _defineProperty({}, _inputModule["default"].disabled, disabled), (0, _classes["default"])('align-self-stretch')),
    disabled: disabled,
    id: id // `inputRef` exists mostly for backwards compatibility
    ,
    ref: inputRef || ref
  }, otherProps)), actionLabel && /*#__PURE__*/_react["default"].createElement(_reactLink["default"], _extends({
    component: "button",
    className: (0, _classnames["default"])(_defineProperty({}, _inputModule["default"]['disabled-action'], disabled), (0, _classes["default"])('margin-right-3')),
    disabled: disabled,
    size: 1
  }, actionProps), actionLabel));

  var hasAction = actionLabel || actionProps;
  var ActionBlockInput = hasAction ? ActionBlockInputWithAction : ActionBlockInputWithoutAction; // Using a custom icon within an Input is deprecated since
  // the v9.5 Atom Studio updates. Maintain this container for
  // backwards-compatibility

  var IconContainerInput = /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])( // eslint-disable-next-line react/prop-types -- directive added automatically by Shepherd migration
    _inputModule["default"]['input-container'], (0, _classes["default"])({
      'width-100': fullWidth
    }))
  }, ActionBlockInput, icon && /*#__PURE__*/_react["default"].createElement("span", {
    className: _inputModule["default"]['icon-container']
  }, icon)); // If still using deprecated custom icon containers,
  // then short circuit and render the legacy
  // input container


  if (icon) {
    return IconContainerInput;
  } // Render ActionBlock directly if none of the
  // InputGroup props are supplied


  if (!willRenderInputGroup) {
    return ActionBlockInput;
  }

  return /*#__PURE__*/_react["default"].createElement(_reactInputGroup["default"], {
    className: className,
    disabled: disabled,
    error: error,
    errorMessage: errorMessage,
    errorMessageId: errorMessageId,
    feedbackMessages: parsedFeedbackMessages,
    helpMessage: helpMessage,
    helpMessageId: helpMessageId,
    input: ActionBlockInput,
    inputId: id,
    fullWidth: fullWidth,
    label: label,
    tooltip: tooltip,
    tooltipPlacement: tooltipPlacement
  });
});

Input.displayName = 'Input';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Input.propTypes = {
    /** Show the input in an error visual state. */
    error: PropTypes.bool,

    /**
     * @deprecated prop to show icon on the right side of the input.
     */
    icon: PropTypes.node,
    feedbackMessages: PropTypes.arrayOf(PropTypes.shape({
      feedbackType: PropTypes.oneOf(Object.values(_reactInputGroup.FEEDBACK_TYPES))
    })),

    /** When true, sets width to 100% on the input. */
    fullWidth: PropTypes.bool,

    /** Disable interaction and change. */
    disabled: PropTypes.bool,

    /** Type attribute on the <input> element. */
    type: PropTypes.string,

    /** Class on the <input> element. */
    className: PropTypes.string,

    /** Gives access to the input dom node */
    inputRef: PropTypes.func,

    /** Label for the input. Components should almost always include a label. */
    label: PropTypes.string,

    /** Optional text to be shown indicating the user is in an error state. */
    errorMessage: PropTypes.node,

    /** Optional help text shown below the input. */
    helpMessage: PropTypes.node,

    /** Optional tooltip shown via an icon next to the label. */
    tooltip: PropTypes.node,

    /** Positioning of tooltip. */
    tooltipPlacement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),

    /** Force the component to use its focus styles. */
    dangerouslyForceFocusStyling: PropTypes.bool,

    /** Force the component to use its hover styles. */
    dangerouslyForceHoverStyling: PropTypes.bool
  };
}

Input.defaultProps = {
  className: null,
  dangerouslyForceFocusStyling: false,
  dangerouslyForceHoverStyling: false,
  disabled: false,
  error: false,
  errorMessage: null,
  feedbackMessages: [],
  fullWidth: false,
  helpMessage: null,
  icon: null,
  inputRef: null,
  label: null,
  tooltip: null,
  tooltipPlacement: null,
  type: 'text'
};
var _default = Input;
exports["default"] = _default;